import type { EnvironmentConfig } from './interfaces.js';

export const environment: EnvironmentConfig = {};
